<template>
	<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:20px">
		<el-breadcrumb-item v-for="(item,index) in breadcrumbPaths" :key="index" :to="item.path">{{item.name}}
		</el-breadcrumb-item>
	</el-breadcrumb>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data(){
			return {
				paths:this.$store.state.cms.breadcrumbPaths
			}
		},
		computed: {
			...mapState('cms', ['breadcrumbPaths'])
		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/party-build/breadcrumb.vue